import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "page" }
const _hoisted_3 = {
  class: "ariane no-mobile",
  itemscope: "",
  itemtype: "https://schema.org/BreadcrumbList"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "https://schema.org/ListItem",
  style: {"padding":"0"}
}, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.location-gardemeuble.fr",
    itemprop: "item"
  }, [
    /*#__PURE__*/_createElementVNode("span", { itemprop: "name" }, "Accueil")
  ]),
  /*#__PURE__*/_createElementVNode("meta", {
    itemprop: "position",
    content: "1"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_6 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "https://schema.org/ListItem",
  style: {"padding":"0"}
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { itemprop: "name" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "2"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_11 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "https://schema.org/ListItem",
  style: {"padding":"0"}
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { itemprop: "name" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "3"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_16 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "https://schema.org/ListItem",
  style: {"padding":"0"}
}
const _hoisted_17 = ["href"]
const _hoisted_18 = { itemprop: "name" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "4"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_21 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "https://schema.org/ListItem",
  style: {"padding":"0"}
}
const _hoisted_22 = ["href"]
const _hoisted_23 = { itemprop: "name" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "5"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "search" }, null, -1)
const _hoisted_26 = { class: "gm" }
const _hoisted_27 = { class: "desktop-top" }
const _hoisted_28 = { class: "desktop-top-right" }
const _hoisted_29 = { class: "infos" }
const _hoisted_30 = { style: {"font-weight":"normal"} }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  href: "#horaires",
  class: "hours-link"
}, " Horaires d'accueil et d'accès ", -1)
const _hoisted_32 = {
  key: 0,
  class: "stars"
}
const _hoisted_33 = { class: "grey" }
const _hoisted_34 = { class: "equipment" }
const _hoisted_35 = { class: "list" }
const _hoisted_36 = { class: "desktop-sizes" }
const _hoisted_37 = { class: "no-mobile guide" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, " Vous avez besoin d'aide pour choisir la taille de votre box ? ", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Essayez notre ")
const _hoisted_40 = ["href"]
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" ou notre ")
const _hoisted_42 = ["href"]
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" ! ")
const _hoisted_44 = { class: "only-mobile" }
const _hoisted_45 = ["href"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", { class: "subtitle no-mobile" }, " Localisation ", -1)
const _hoisted_48 = { class: "map no-mobile" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("button", { class: "button black" }, " Voir sur la carte ", -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "links no-mobile" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["src", "alt"]
const _hoisted_54 = { class: "desc" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "fleche" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.location-gardemeuble.fr/img/ariane_s.png",
    alt: "",
    width: "10",
    height: "25"
  })
], -1)
const _hoisted_56 = { class: "links only-mobile" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["src", "alt"]
const _hoisted_59 = { class: "desc" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "fleche" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.location-gardemeuble.fr/img/ariane_s.png",
    alt: "",
    width: "10",
    height: "25"
  })
], -1)
const _hoisted_61 = { class: "description" }
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Lire la suite ... ")
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Réduire ")
const _hoisted_65 = {
  key: 0,
  class: "description"
}
const _hoisted_66 = { style: {"margin":"1em 0"} }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Le prix moyen d’un box de stockage chez ")
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" est de ")
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" par mois par m")
const _hoisted_71 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_73 = { key: 1 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" Le prix moyen d’un box de stockage à ")
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" et ses alentours est de ")
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" par mois par m")
const _hoisted_78 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_79 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_80 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Le prix moyen d’un box de stockage dans le département ")
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" est de ")
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" par mois par m")
const _hoisted_84 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_85 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_86 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" Le prix moyen d’un box de stockage dans la région ")
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" est de ")
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" par mois par m")
const _hoisted_90 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_91 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_92 = { style: {"font-size":"0.75em"} }
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" Les prix sont donnés à titre indicatif et peuvent varier en fonction de la taille du box, de la localisation et des services proposés. ")
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_95 = {
  key: 1,
  class: "description"
}
const _hoisted_96 = { style: {"margin":"1em 0"} }
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" La taille de box la plus demandée chez ")
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" est habituellement de ")
const _hoisted_99 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_100 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_101 = { style: {"font-size":"0.75em"} }
const _hoisted_102 = {
  key: 2,
  class: "faq",
  itemscope: "",
  itemtype: "https://schema.org/FAQPage"
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("h3", null, " Questions - réponses sur le centre de stockage ", -1)
const _hoisted_104 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question"
}
const _hoisted_105 = { itemprop: "name" }
const _hoisted_106 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_107 = { itemprop: "text" }
const _hoisted_108 = { style: {"margin-top":"0.5em"} }
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" Lire la suite ... ")
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" Réduire ")
const _hoisted_111 = { class: "description about" }
const _hoisted_112 = { class: "hours" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("h3", { class: "hours-link" }, " Adresse ", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_115 = { class: "hours" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("h3", { class: "hours-link" }, " Caractéristiques principales des espaces de stockage ", -1)
const _hoisted_117 = { key: 0 }
const _hoisted_118 = ["href"]
const _hoisted_119 = {
  id: "horaires",
  class: "hours"
}
const _hoisted_120 = /*#__PURE__*/_createElementVNode("h3", { class: "hours-link" }, " Horaires et jours : Accueil - Visite ", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("p", null, "Vous pouvez rendre visite au garde meuble ou vous procurer des cartons (si le centre le propose) aux horaires suivants :", -1)
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" Pour vous réserver le meilleur accueil et vous éviter toute attente, pensez à prendre rendez-vous avant de passer nous voir ! ")
const _hoisted_123 = { class: "hours" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("h3", { class: "hours-link" }, " Quand puis-je accéder à mon espace de rangement ? ", -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("p", null, "Vous trouverez ci-dessous les heures où vous pouvez venir récupérer ou déposer des affaires dans votre local de stockage :", -1)
const _hoisted_126 = {
  id: "gm-avis",
  class: "avis",
  ref: "avisBox"
}
const _hoisted_127 = {
  key: 0,
  class: "no-mobile"
}
const _hoisted_128 = { class: "gm-nearby" }
const _hoisted_129 = { class: "near" }
const _hoisted_130 = { class: "subtitle" }
const _hoisted_131 = { class: "nearby" }
const _hoisted_132 = ["href", "title"]
const _hoisted_133 = { class: "popular" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("h3", null, "Expression populaire", -1)
const _hoisted_135 = ["href"]
const _hoisted_136 = {
  key: 3,
  class: "shadow-box"
}
const _hoisted_137 = { class: "region-departement" }
const _hoisted_138 = ["href"]
const _hoisted_139 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_140 = ["href"]
const _hoisted_141 = { class: "pays" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("h2", null, "Trouver un garde-meuble sécurisé en France", -1)
const _hoisted_143 = ["href", "title"]
const _hoisted_144 = { class: "conseils" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("h2", null, "Nos conseils déménagement et self-stockage", -1)
const _hoisted_146 = ["innerHTML"]
const _hoisted_147 = ["href"]
const _hoisted_148 = /*#__PURE__*/_createTextVNode(" Lire la suite ... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_AddressModal = _resolveComponent("AddressModal")!
  const _component_AvisModal = _resolveComponent("AvisModal")!
  const _component_CallbackModal = _resolveComponent("CallbackModal")!
  const _component_ContactModal = _resolveComponent("ContactModal")!
  const _component_RendezVousModal = _resolveComponent("RendezVousModal")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Actions = _resolveComponent("Actions")!
  const _component_Boxes = _resolveComponent("Boxes")!
  const _component_Map = _resolveComponent("Map")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_AvisSummary = _resolveComponent("AvisSummary")!
  const _component_Avis = _resolveComponent("Avis")!
  const _component_NearbyGM = _resolveComponent("NearbyGM")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (this.store.state.gm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Header),
          _createElementVNode("div", null, [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (this.store.state.address_modal)
                  ? (_openBlock(), _createBlock(_component_AddressModal, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (this.store.state.avis_modal)
                  ? (_openBlock(), _createBlock(_component_AvisModal, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (this.store.state.callback_modal)
                  ? (_openBlock(), _createBlock(_component_CallbackModal, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (this.store.state.contact_modal)
                  ? (_openBlock(), _createBlock(_component_ContactModal, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (this.store.state.rdv_modal)
                  ? (_openBlock(), _createBlock(_component_RendezVousModal, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              type: "application/ld+json",
              "data-pagespeed-no-transform": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": \"LocalBusiness\", \"name\": \"" + _toDisplayString(this.store.state.gm.name) + "\", \"image\": \"" + _toDisplayString(this.store.state.gm?.images[0]?.url) + "\", \"address\": { \"@type\": \"PostalAddress\", \"streetAddress\": \"" + _toDisplayString(this.store.state.gm.address) + "\", \"addressLocality\": \"" + _toDisplayString(this.store.state.gm.city.name) + "\", \"postalCode\": \"" + _toDisplayString(this.store.state.gm.city.postcode) + "\", \"addressRegion\": \"" + _toDisplayString(this.store.state.gm.city.departement.name) + "\", \"addressCountry\": \"FR\" }, \"url\": \"" + _toDisplayString(this.store.state.gm.url) + "\", \"telephone\": \"" + _toDisplayString(this.store.state.gm.phone) + "\", \"priceRange\": \"€€\" } ", 1)
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              type: "application/ld+json",
              "data-pagespeed-no-transform": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": \"AggregateRating\", \"itemReviewed\": { \"@type\": \"LocalBusiness\", \"name\": \"" + _toDisplayString(this.store.state.gm.name) + "\", \"image\": \"" + _toDisplayString(this.store.state.gm?.images[0]?.url) + "\", \"address\": { \"@type\": \"PostalAddress\", \"streetAddress\": \"" + _toDisplayString(this.store.state.gm.address) + "\", \"addressLocality\": \"" + _toDisplayString(this.store.state.gm.city.name) + "\", \"postalCode\": \"" + _toDisplayString(this.store.state.gm.city.postcode) + "\", \"addressRegion\": \"" + _toDisplayString(this.store.state.gm.city.departement.name) + "\", \"addressCountry\": \"FR\" }, \"url\": \"" + _toDisplayString(this.store.state.gm.url) + "\", \"telephone\": \"" + _toDisplayString(this.store.state.gm.phone) + "\", \"priceRange\": \"€€\" }, \"ratingValue\": \"" + _toDisplayString(this.store.state.gm.note) + "\", \"reviewCount\": \"" + _toDisplayString(this.store.state.gm.avis.length) + "\" } ", 1)
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              type: "application/ld+json",
              "data-pagespeed-no-transform": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": [\"SelfStorage\"], \"mainEntityOfPage\": { \"@type\": \"WebPage\", \"@id\": \"" + _toDisplayString(this.store.state.gm.url) + "\" }, \"name\": \"Location de garde-meubles à " + _toDisplayString(this.store.state.gm.city.name) + "\", \"image\": \"" + _toDisplayString(this.store.state.gm?.images[0]?.url) + "\", \"priceRange\": \"€€\", \"address\": { \"@type\": \"PostalAddress\", \"addressLocality\": \"" + _toDisplayString(this.store.state.gm.city.name) + "\", \"postalCode\": \"" + _toDisplayString(this.store.state.gm.city.postcode) + "\" }, \"aggregateRating\": { \"@type\": \"AggregateRating\", \"ratingValue\": \"" + _toDisplayString(this.store.state.gm.note) + "\", \"reviewCount\": \"" + _toDisplayString(this.store.state.gm.avis.length) + "\", \"bestRating\": \"5\" }, \"hasOfferCatalog\": { \"@type\": \"OfferCatalog\", \"name\": \"Nos boxes de stockage à " + _toDisplayString(this.store.state.gm.city.name) + "\", \"itemListElement\": [ " + _toDisplayString(this.jsonBoxesLD()) + " ] }, \"additionalProperty\": [ " + _toDisplayString(this.jsonServicesLD()) + " ] } ", 1)
              ]),
              _: 1
            })),
            _withDirectives(_createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("a", {
                    href: this.store.state.gm.city_url.region.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                    itemprop: "item"
                  }, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(this.store.state.gm.city_url?.region?.name), 1)
                  ], 8, _hoisted_7),
                  _hoisted_9
                ]),
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, [
                  _createElementVNode("a", {
                    href: this.store.state.gm.city_url.departement.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                    itemprop: "item"
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(this.store.state.gm.city_url?.departement?.name), 1)
                  ], 8, _hoisted_12),
                  _hoisted_14
                ]),
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("a", {
                    href: this.store.state.gm.city_url.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                    itemprop: "item"
                  }, [
                    _createElementVNode("span", _hoisted_18, "Garde meuble " + _toDisplayString(this.store.state.gm.city_url.name), 1)
                  ], 8, _hoisted_17),
                  _hoisted_19
                ]),
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, [
                  _createElementVNode("a", {
                    href: this.store.state.gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                    itemprop: "item"
                  }, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(this.store.state.gm.name), 1)
                  ], 8, _hoisted_22),
                  _hoisted_24
                ])
              ]),
              _hoisted_25,
              _createElementVNode("h1", null, " Location box, garde meuble " + _toDisplayString(this.store.state.gm.city_url.name) + " " + _toDisplayString(this.store.state.gm.enseigne), 1),
              _createElementVNode("section", _hoisted_26, [
                _createElementVNode("article", null, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Carousel),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("h2", _hoisted_30, " Location box de stockage à " + _toDisplayString(this.store.state.gm.city.name), 1),
                        _hoisted_31,
                        (this.store.state.gm.avis.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createElementVNode("a", {
                                href: "#gm-avis",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (this.store.state.counter( 'avis', this.store.state.gm.id, () => '' )))
                              }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_33, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                                      return _createVNode(_component_font_awesome_icon, {
                                        key: index,
                                        icon: "star"
                                      })
                                    }), 64))
                                  ]),
                                  _createElementVNode("div", {
                                    class: "gold",
                                    style: _normalizeStyle({ width : ( this.store.state.gm.note / 5 * 100 ) + '%' })
                                  }, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                                      return _createVNode(_component_font_awesome_icon, {
                                        key: index,
                                        icon: "star"
                                      })
                                    }), 64))
                                  ], 4)
                                ]),
                                _createElementVNode("span", null, _toDisplayString(this.store.state.gm.note.toFixed( 1 )) + " / 5.0 étoiles basées sur " + _toDisplayString(this.store.state.gm.avis.length) + " avis ", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.services_with_icons, (key, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "item",
                              key: key
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass('service service-'+key)
                              }, null, 2),
                              _createElementVNode("div", null, _toDisplayString(this.store.state.gm.services[key]), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(_component_Actions),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("p", null, [
                          _hoisted_39,
                          _createElementVNode("a", {
                            href: this.store.state.base_url + 'calculateur-de-volume',
                            target: "_blank"
                          }, "calculateur de volume", 8, _hoisted_40),
                          _hoisted_41,
                          _createElementVNode("a", {
                            href: this.store.state.base_url + 'guide-taille',
                            target: "_blank"
                          }, "guide de taille de box", 8, _hoisted_42),
                          _hoisted_43
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("a", {
                          href: this.store.state.base_url + 'calculateur-de-volume',
                          target: "_blank",
                          class: "button",
                          style: {"text-align":"center","text-decoration":"none","font-weight":"normal","margin-bottom":"1.75em","width":"100%","font-size":"1em"}
                        }, " Calculateur de volume ", 8, _hoisted_45)
                      ]),
                      _createVNode(_component_Boxes)
                    ]),
                    _createElementVNode("div", null, [
                      (this.store.state.gm.promo.general && this.store.state.gm.promo.general.replace(/(<([^>]+)>)/gi, '').trim().length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "promo",
                            innerHTML: _ctx.linksNofollow( this.store.state.gm.promo.general ),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.store.state.counter( 'url', this.store.state.gm.id, () => '' )))
                          }, null, 8, _hoisted_46))
                        : _createCommentVNode("", true),
                      _hoisted_47,
                      _createElementVNode("div", _hoisted_48, [
                        (!this.map_shown)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => {this.map_shown = true; this.store.state.counter( 'map', this.store.state.gm.id, () => '' )})
                            }, _hoisted_50))
                          : _createCommentVNode("", true),
                        _createVNode(_Transition, { name: "fade" }, {
                          default: _withCtx(() => [
                            (this.map_shown && this.store.getters.isDesktop)
                              ? (_openBlock(), _createBlock(_component_Map, { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.partners, (partenaire) => {
                          return _withDirectives((_openBlock(), _createElementBlock("a", {
                            href: "#",
                            onClick: _withModifiers(() => { if( partenaire.name === 'Assurbox' ) { this.store.state.counter( 'assurbox', this.store.state.gm.id, () => this.window.open( partenaire.url, '_blank' ).focus() ) } else { this.window.open( partenaire.url, '_blank' ).focus() } }, ["prevent"]),
                            target: "_blank",
                            rel: "noopener nofollow"
                          }, [
                            _createElementVNode("img", {
                              src: partenaire.img,
                              alt: partenaire.name,
                              width: "250",
                              height: "110"
                            }, null, 8, _hoisted_53),
                            _createElementVNode("div", _hoisted_54, _toDisplayString(partenaire.desc), 1),
                            _hoisted_55
                          ], 8, _hoisted_52)), [
                            [_vShow, partenaire.enabled]
                          ])
                        }), 256))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.partners, (partenaire) => {
                      return _withDirectives((_openBlock(), _createElementBlock("a", {
                        href: "#",
                        onClick: _withModifiers(() => { if( partenaire.name === 'Assurbox' ) { this.store.state.counter( 'assurbox', this.store.state.gm.id, () => this.window.open( partenaire.url, '_blank' ).focus() ) } else { this.window.open( partenaire.url, '_blank' ).focus() } }, ["prevent"]),
                        target: "_blank",
                        rel: "noopener"
                      }, [
                        _createElementVNode("img", {
                          src: partenaire.img,
                          alt: partenaire.name,
                          width: "250",
                          height: "110"
                        }, null, 8, _hoisted_58),
                        _createElementVNode("div", _hoisted_59, _toDisplayString(partenaire.desc), 1),
                        _hoisted_60
                      ], 8, _hoisted_57)), [
                        [_vShow, partenaire.enabled]
                      ])
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("h2", null, "Aperçu du garde meuble à louer à " + _toDisplayString(this.store.state.gm.city_url.name), 1),
                    _createElementVNode("div", {
                      innerHTML: this.store.state.gm.description,
                      class: _normalizeClass(this.description_shown ? 'collapsable expanded' : 'collapsable')
                    }, null, 10, _hoisted_62),
                    (!this.description_shown)
                      ? (_openBlock(), _createElementBlock("small", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (this.description_shown = true))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                          _hoisted_63
                        ]))
                      : _createCommentVNode("", true),
                    (this.description_shown)
                      ? (_openBlock(), _createElementBlock("small", {
                          key: 1,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (this.description_shown = false))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                          _hoisted_64
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (this.store.state.gm.prices)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("h3", null, " Quel est le prix moyen d'un box de stockage chez " + _toDisplayString(this.store.state.gm.name) + " ? ", 1),
                        _createVNode(_component_Bar, {
                          chartData: this.charts?.tarif?.data,
                          chartOptions: this.charts?.tarif?.options,
                          style: {"width":"100%","max-width":"min(1000px, 95vw)","height":"300px","margin":"auto"}
                        }, null, 8, ["chartData", "chartOptions"]),
                        _createElementVNode("p", _hoisted_66, [
                          (this.getPriceChartData()[0] > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("b", null, _toDisplayString(this.store.state.gm?.name), 1),
                                _hoisted_69,
                                _createElementVNode("b", null, _toDisplayString(this.getPriceChartData()[0]) + " euros", 1),
                                _hoisted_70,
                                _hoisted_71,
                                _hoisted_72
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_73, " Nous n'avons pas suffisamment de données pour afficher le prix moyen d'un box de stockage chez " + _toDisplayString(this.store.state.gm.name) + ". ", 1)),
                          _hoisted_74,
                          _hoisted_75,
                          _createElementVNode("b", null, _toDisplayString(this.store.state.gm?.city?.name), 1),
                          _hoisted_76,
                          _createElementVNode("b", null, _toDisplayString(this.getPriceChartData()[1]) + " euros", 1),
                          _hoisted_77,
                          _hoisted_78,
                          _hoisted_79,
                          _hoisted_80,
                          _hoisted_81,
                          _createElementVNode("b", null, _toDisplayString(this.store.state.gm?.city.departement?.name), 1),
                          _hoisted_82,
                          _createElementVNode("b", null, _toDisplayString(this.getPriceChartData()[2]) + " euros", 1),
                          _hoisted_83,
                          _hoisted_84,
                          _hoisted_85,
                          _hoisted_86,
                          _hoisted_87,
                          _createElementVNode("b", null, _toDisplayString(this.store.state.gm?.city.region?.name), 1),
                          _hoisted_88,
                          _createElementVNode("b", null, _toDisplayString(this.getPriceChartData()[3]) + " euros", 1),
                          _hoisted_89,
                          _hoisted_90,
                          _hoisted_91
                        ]),
                        _createElementVNode("small", _hoisted_92, [
                          _hoisted_93,
                          _hoisted_94,
                          _createTextVNode(" Données basées sur les annonces de garde meubles à " + _toDisplayString(this.store.state.gm.city.name) + " publiées sur Location-gardemeuble.fr en " + _toDisplayString(this.getMonthYear()) + ". ", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (this.store.state.gm.sizes && this.getSizeMostWanted() > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                        _createElementVNode("h3", null, " Quelle est la taille de box la plus demandée chez " + _toDisplayString(this.store.state.gm.name) + " ? ", 1),
                        _createVNode(_component_Bar, {
                          chartData: this.charts?.size?.data,
                          chartOptions: this.charts?.size?.options,
                          style: {"width":"100%","max-width":"min(1000px, 95vw)","height":"300px","margin":"auto"}
                        }, null, 8, ["chartData", "chartOptions"]),
                        _createElementVNode("p", _hoisted_96, [
                          _hoisted_97,
                          _createElementVNode("b", null, _toDisplayString(this.store.state.gm?.name), 1),
                          _hoisted_98,
                          _createElementVNode("b", null, [
                            _createTextVNode(_toDisplayString(this.getSizeMostWanted()) + " m", 1),
                            _hoisted_99
                          ]),
                          _hoisted_100
                        ]),
                        _createElementVNode("small", _hoisted_101, " Données basées sur les réservations chez " + _toDisplayString(this.store.state.gm.name) + ", effectuées sur Location-gardemeuble.fr en " + _toDisplayString(this.getMonthYear()) + " et sur les 12 derniers mois. ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (this.store.state.gm.faq.questions.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                        _hoisted_103,
                        _createElementVNode("div", {
                          class: _normalizeClass(this.faq_shown ? 'collapsable expanded' : 'collapsable')
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.faq.questions, (faq, key) => {
                            return (_openBlock(), _createElementBlock("article", _hoisted_104, [
                              _createElementVNode("h3", _hoisted_105, _toDisplayString(this.store.state.gm.faq.questions[key]), 1),
                              _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("div", _hoisted_107, _toDisplayString(this.store.state.gm.faq.answers[key]), 1)
                              ])
                            ]))
                          }), 256))
                        ], 2),
                        _createElementVNode("div", _hoisted_108, [
                          (!this.faq_shown)
                            ? (_openBlock(), _createElementBlock("small", {
                                key: 0,
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (this.faq_shown = true))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                                _hoisted_109
                              ]))
                            : _createCommentVNode("", true),
                          (this.faq_shown)
                            ? (_openBlock(), _createElementBlock("small", {
                                key: 1,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (this.faq_shown = false))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                                _hoisted_110
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("h2", null, " A propos de la location de box " + _toDisplayString(this.store.state.gm.city_url.name) + " " + _toDisplayString(this.store.state.gm.enseigne), 1),
                    _createElementVNode("div", _hoisted_112, [
                      _hoisted_113,
                      _createElementVNode("p", null, [
                        _createTextVNode(" La plupart des personnes recherchent un box à louer près de chez eux. D'autres, pour bénéficier d'un prix moins élevé sont prêts à s'éloigner. Quelle que soit la raison, veuillez trouver l'adresse du garde meuble " + _toDisplayString(this.store.state.gm.name) + " à " + _toDisplayString(this.store.state.gm.city.name) + " : ", 1),
                        _hoisted_114,
                        _createTextVNode(" " + _toDisplayString(this.store.state.gm.address) + " - " + _toDisplayString(this.store.state.gm.city.name) + " " + _toDisplayString(this.store.state.gm.city.cp), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("b", null, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => {this.store.state.address_modal = true; this.store.state.counter( 'save', this.store.state.gm.id, () => '' );}, ["prevent"])),
                            style: {"cursor":"pointer"}
                          }, " Ne vous trompez pas d'adresse, recevez là par mail ! ")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_115, [
                      _hoisted_116,
                      _createElementVNode("p", null, " De nombreux points clés permettent de louer un box de façon confortable. Voici une liste non exhaustive des points forts de " + _toDisplayString(this.store.state.gm.name) + " - " + _toDisplayString(this.store.state.gm.city.name) + " : ", 1),
                      _createElementVNode("p", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.services, (service, key, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: key }, _toDisplayString(index > 0 ? " – " : "") + " " + _toDisplayString(service), 1))
                        }), 128))
                      ]),
                      (typeof( this.store.state.gm.web ) === 'string' && this.store.state.gm.web.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_117, [
                            _createElementVNode("a", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (this.store.state.counter( 'url', this.store.state.gm.id, () => '' ))),
                              href: this.store.state.gm.web,
                              rel: "nofollow",
                              target: "_blank",
                              style: {"font-weight":"normal"}
                            }, " Plus d'information sur notre site web ", 8, _hoisted_118)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _hoisted_121,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.hours.open, (hour, index) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("b", null, _toDisplayString((new Date( "1970-02-0" + (index + 2) )).toLocaleString( "fr-FR", { weekday : "long" } )) + " : ", 1),
                          _createTextVNode(" " + _toDisplayString(hour), 1)
                        ]))
                      }), 256)),
                      _createElementVNode("p", null, [
                        _createElementVNode("b", null, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => {this.store.state.rdv_modal = true;}, ["prevent"])),
                            style: {"cursor":"pointer"}
                          }, " Envie de visiter ? ")
                        ]),
                        _hoisted_122
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _hoisted_124,
                      _hoisted_125,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.hours.access, (hour, index) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("b", null, _toDisplayString((new Date( "1970-02-0" + (index + 2) )).toLocaleString( "fr-FR", { weekday : "long" } )) + " : ", 1),
                          _createTextVNode(" " + _toDisplayString(hour), 1)
                        ]))
                      }), 256))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_126, [
                    (this.store.getters.isDesktop)
                      ? (_openBlock(), _createElementBlock("h2", _hoisted_127, " Avis "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => {this.store.state.avis_modal = !this.store.state.avis_modal;}),
                      class: "button mob-100 black",
                      style: {"display":"block","margin":"10px auto","font-size":"1em","text-align":"center","font-weight":"normal","text-decoration":"none"}
                    }, " Écrire un avis "),
                    (this.store.getters.isDesktop)
                      ? (_openBlock(), _createBlock(_component_AvisSummary, { key: 1 }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Avis)
                  ], 512),
                  _createElementVNode("div", _hoisted_128, [
                    _createElementVNode("h2", null, " Autres box à louer près de " + _toDisplayString(this.store.state.gm.city_url.name), 1),
                    _createVNode(_component_NearbyGM)
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("h3", _hoisted_130, " Trouver le prix d’un box près de " + _toDisplayString(this.store.state.gm.city.name), 1),
                    _createElementVNode("div", _hoisted_131, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.near, (city, city_name) => {
                        return (_openBlock(), _createElementBlock("a", {
                          href: city.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                          title: city.label,
                          class: "nearby"
                        }, _toDisplayString(city.label), 9, _hoisted_132))
                      }), 256))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_133, [
                    _hoisted_134,
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.terms, (term, key, index) => {
                        return (_openBlock(), _createElementBlock("span", null, [
                          _createTextVNode(_toDisplayString(index > 0 ? " – " : "") + " ", 1),
                          _createElementVNode("a", {
                            href: term.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url )
                          }, _toDisplayString(term.label), 9, _hoisted_135)
                        ]))
                      }), 256))
                    ])
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                        _createElementVNode("div", _hoisted_137, [
                          _createElementVNode("a", {
                            href: this.store.state.gm.city.region.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url )
                          }, [
                            _createElementVNode("h3", null, " Voir les locations de garde meubles Région " + _toDisplayString(this.store.state.gm.city.region.name), 1)
                          ], 8, _hoisted_138),
                          _hoisted_139,
                          _createElementVNode("a", {
                            href: this.store.state.gm.city.departement.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url )
                          }, [
                            _createElementVNode("h2", null, " Voir la liste des garde-meubles " + _toDisplayString(this.store.state.gm.city.departement.name), 1)
                          ], 8, _hoisted_140)
                        ]),
                        _createElementVNode("div", _hoisted_141, [
                          _hoisted_142,
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.big, (city_url, city_name, index) => {
                              return (_openBlock(), _createElementBlock("span", null, [
                                _createTextVNode(_toDisplayString(index > 0 ? " – " : "") + " ", 1),
                                _createElementVNode("a", {
                                  href: city_url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                                  title: 'Garde meuble ' + city_name
                                }, " Garde meuble " + _toDisplayString(city_name), 9, _hoisted_143)
                              ]))
                            }), 256))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("section", _hoisted_144, [
                    _hoisted_145,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.articles, (article) => {
                      return (_openBlock(), _createElementBlock("article", null, [
                        _createElementVNode("h3", null, _toDisplayString(article.title), 1),
                        _createElementVNode("p", {
                          innerHTML: article.extract
                        }, null, 8, _hoisted_146),
                        _createElementVNode("small", null, [
                          _createElementVNode("a", {
                            href: article.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url )
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                            _hoisted_148
                          ], 8, _hoisted_147)
                        ])
                      ]))
                    }), 256))
                  ])
                ])
              ])
            ], 512), [
              [_vShow, ( this.store.getters.isMobile && !this.store.state.address_modal && !this.store.state.avis_modal && !this.store.state.callback_modal && !this.store.state.contact_modal && !this.store.state.rdv_modal ) || (!this.store.getters.isMobile)]
            ])
          ]),
          _createVNode(_component_Footer)
        ]))
      : _createCommentVNode("", true)
  ]))
}